import React, { useState } from "react";
import "./Subscription_Plan.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWallet } from "@fortawesome/free-solid-svg-icons";
import Subscription_Plan_Modal from "./subscription_plan_modal/Subscription_Plan_Modal";

const Subscription_Plan = () => {
  const [selectedPlan, setSelectedPlan] = useState("yearly");
  const [showModal, setShowModal] = useState(false);
  const handleAddSubscriptionClick = () => {
    setShowModal(true);

    setTimeout(() => {
      setShowModal(false);
    }, 3000);
  };
  const handleCloseModal = () => {};

  return (
    <div className="sub-container container">
      <div className="sub-card">
        <h3 className="sub-title">Choose Subscription Plan</h3>

        <div className="sub-plans">
          <label
            className={`plan-item yearly ${
              selectedPlan === "yearly" ? "active" : ""
            }`}
          >
            <div className="plan-details">
              <span className="plan-name">
                YEARLY <span className="badge">Best value</span>
              </span>
              <span className="plan-price">
                ₹200 <small>/month</small>
              </span>
            </div>
            <input
              type="radio"
              name="subscription"
              value="yearly"
              checked={selectedPlan === "yearly"}
              onChange={() => setSelectedPlan("yearly")}
            />
            <div className="custom-radio-outer">
              <div className="custom-radio-inner"></div>
            </div>
          </label>

          <label
            className={`plan-item monthly ${
              selectedPlan === "monthly" ? "active" : ""
            }`}
          >
            <div className="plan-details">
              <span className="plan-name">MONTHLY</span>
              <span className="plan-price">
                ₹300 <small>/month</small>
              </span>
            </div>
            <input
              type="radio"
              name="subscription"
              value="monthly"
              checked={selectedPlan === "monthly"}
              onChange={() => setSelectedPlan("monthly")}
            />
            <div className="custom-radio-outer">
              <div className="custom-radio-inner"></div>
            </div>
          </label>
        </div>

        <div className="payment-section">
          <h3 className="sub-title">Payment method</h3>
          <div className="payment-method-box">
            <div className="payment-info">
              <span className="wallet-icon">
                <FontAwesomeIcon icon={faWallet} />
              </span>
              <span className="wallet-text">Wallet (₹1500)</span>
            </div>
            <div className="radio-selected-wrapper">
              <div className="radio-selected-inner"></div>
            </div>
          </div>
        </div>

        <button className="pay-now-btn" onClick={handleAddSubscriptionClick}>
          Pay Now
        </button>
      </div>

      <Subscription_Plan_Modal
        showAddsubscription={showModal}
        handleAddSubscriptionClose={handleCloseModal}
      />
    </div>
  );
};

export default Subscription_Plan;
